import { gql } from "@apollo/client";

export const UPDATE_DOC_ITEMS = gql`
	mutation UpdateDocumentItems($input: UpdateDocumentItemsInput!) {
		updateDocumentItems(input: $input) {
			_id
		}
	}
`;
